export const environment = {
  production: false,
  environment: 'uat',
  auth: {
      clientId: 'd56045a2-c113-48ac-905d-782f0901f412',
      authority: 'https://login.microsoftonline.com/76b5b304-4736-44dc-ba8c-944e061047eb',
      redirectUri: 'https://tsuat.dnv.org/',
      postLogoutRedirectUri: 'https://tsuat.dnv.org/',
  }
};
